import * as React from 'react';
import { Card } from "react-bootstrap";
import './UpdateBeneficiaries.css';
import { UpdateBeneficiariesItem } from "./UpdateBeneficiariesItem";

interface UpdateBeneficiariesProps {
    beneficiaries: {name: string, percentage: string}[];
    emitHandleBack: any;
    emitHandleAddBeneficiary: any;
    emitHandleViewOrUpdate: any;
    emitHandleRemove: any;
}

export class UpdateBeneficiaries extends React.Component<UpdateBeneficiariesProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }

        this.handleAddBeneficiary = this.handleAddBeneficiary.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleViewOrUpdate = this.handleViewOrUpdate.bind(this);
    }
    
    handleBack() {
        this.props.emitHandleBack();
    }
    
    handleAddBeneficiary() {
        this.props.emitHandleAddBeneficiary();
    }
    
    handleViewOrUpdate(id) {
        this.props.emitHandleViewOrUpdate(id);
    }
    
    handleRemove(id) {
        this.props.emitHandleRemove(id);
    }

    public render() {
        return <div className="update-beneficiaries">
            <Card>
                <Card.Title className="pb-0 pl-4 pt-4">
                    <h3 className="mb-0 update-beneficiaries__title">Update beneficiaries</h3>
                </Card.Title>
                <Card.Body id="update-beneficiaries__card-body">
                    <hr className="mb-0 mt-0" />
                    { this.props.beneficiaries.map((beneficiary, index) =>
                        <>
                        <UpdateBeneficiariesItem emitHandleViewOrUpdate={this.handleViewOrUpdate} emitHandleRemove={this.handleRemove} beneficiary={beneficiary}>
                        { this.props.beneficiaries.length > 0 && <hr className="mb-0 mt-0" /> }
                        </UpdateBeneficiariesItem>
                        <hr />
                        </>
                    )}
                    {!this.props.beneficiaries || this.props.beneficiaries.length == 0 && <h5 className="text-center mt-3">No beneficiaries</h5> }
                    <div className="update-beneficiaries__actions row justify-content-end mt-5 pb-5 pr-5">
                        <div className="col-5">
                            <button onClick={this.handleBack} className="btn btn-outline-red w-100">Back</button>
                        </div>
                        <div className="col-5">
                            <button onClick={this.handleAddBeneficiary} className="btn btn-solid-red w-100">Add beneficiary</button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    }
}
